module.exports = __webpack_public_path__ + "static/img/groundD1.1b7b1b34.png";